// Angular
import { NgModule, ErrorHandler } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { BrowserModule, HammerGestureConfig, HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

// Library
import { ModalModule } from 'ngx-bootstrap/modal';

// https://github.com/hammerjs/hammer.js/issues/1014
import * as Hammer from 'hammerjs';
export class HammerConfig extends HammerGestureConfig {
  buildHammer(element: HTMLElement) {
    let options = {};

    if (element.attributes['data-mc-options']) {
      try {
        const parseOptions = JSON.parse(element.attributes['data-mc-options'].nodeValue);
        options = parseOptions;
      } catch (err) {
        console.error('An error occurred when attempting to parse Hammer.js options: ', err);
      }
    }

    const mc = new Hammer(element, options);

    // keep default angular config
    mc.get('pinch').set({ enable: true });
    mc.get('rotate').set({ enable: true });

    // retain support for angular overrides object
    for (const eventName of Object.keys(this.overrides)) {
      mc.get(eventName).set(this.overrides[eventName]);
    }

    return mc;
  }
}

// Common
import { SharedService } from './common-app/service/shared.service';
import { LocalStorageService } from './common-app/service/local-storage.service';
import { RestApiService, REST_API_CONFIG } from './common-app/service/rest-api.service';
import { AutoSaveDirective } from './common-app/directive/auto-save.directive';
import { ChangeDetectionDirective } from './common-app/directive/change-detection.directive';
import { RouteLogService } from './common-app/service/route-log.service';
// 利用していないが、ng build --prod でエラーが発生するため
import { ErrorComponent } from './common-app/component/error/error.component';


// App
import { environment } from '../environments/environment';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { AppErrorHandler } from './error-handler/app.error-handler';
import { ErrorDialogComponent } from './error-handler/error-dialog.component';

import { HeaderComponent } from './component/header/header.component';
import { Kvap0300Component } from './component/kvap0300/kvap0300.component';
import { Kvap0301Component } from './component/kvap0301/kvap0301.component';
import { Kvap0302Component } from './component/kvap0302/kvap0302.component';
import { Kvap0400Component } from './component/kvap0400/kvap0400.component';
import { Kvap0500Component } from './component/kvap0500/kvap0500.component';
import { Kvap0600Component } from './component/kvap0600/kvap0600.component';
import { Kvap0700Component } from './component/kvap0700/kvap0700.component';
import { Kvap0800Component } from './component/kvap0800/kvap0800.component';


@NgModule({
  imports: [
    // Angular modules
    BrowserModule,
    ReactiveFormsModule,
    HttpClientModule,
    // Template-driven forms
    FormsModule,

    // Bootstrap modules
    ModalModule.forRoot(),

    BrowserAnimationsModule,

    // App modules
    AppRoutingModule,
  ],
  providers: [
    SharedService,
    RestApiService,
    LocalStorageService,
    {
      provide: ErrorHandler,
      useClass: AppErrorHandler
    },
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy
    },
    {
      provide: REST_API_CONFIG,
      useValue: environment.apiUrl,
    },
    {
      provide: HAMMER_GESTURE_CONFIG,
      useClass: HammerConfig,
    },
    RouteLogService,
  ],
  declarations: [
    // root component
    AppComponent,
    ErrorDialogComponent,
    ErrorComponent,

    AutoSaveDirective,
    ChangeDetectionDirective,

    HeaderComponent,
    Kvap0300Component,
    Kvap0301Component,
    Kvap0302Component,
    Kvap0400Component,
    Kvap0500Component,
    Kvap0600Component,
    Kvap0700Component,
    Kvap0800Component,
  ],
  entryComponents: [
    ErrorDialogComponent,
  ],
  bootstrap: [
    // Angular starts from the component
    AppComponent,
  ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts